import { Directive, OnDestroy, OnInit, inject } from '@angular/core';
import { AppBusyStateBroadcasterComponentDef } from '@df/ui/display/busy-state/app-busy-state-broadcaster.component.def';
import { RouterBusyStateService } from '@df/ui/display/busy-state/router-busy-state.service';
import { Subscription } from 'rxjs';

@Directive()
export abstract class RouterAppBusyStateComponentDef extends AppBusyStateBroadcasterComponentDef implements OnInit, OnDestroy {
    private routerBusyStateService = inject(RouterBusyStateService);

    private subscription?: Subscription;

    ngOnInit(): void {
        this.subscription = this.routerBusyStateService.busy$.subscribe(busy => {
            busy ? this.show() : this.hide();
        });
    }

    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
    }
}
